import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Sidebar from "../components/dashboard/Sidebar";
import ContentArea from "../components/templates/ContentArea";
import {
  loadFeaturedTemplates,
  loadTemplateCategories,
  loadUserTemplates,
} from "../thunks/dashboardThunks";
import UserProfileModal from "./Profile";
import {
  closeCansvasSizeModal,
  closeProfileModal,
  selectIsCanvasSizeModal,
  selectIsProfileModalOpen,
} from "../store/common/profileModalSlice";
import CanvasSizeModal from "../components/dashboard/CanvasSizeModal";

const TemplatesPage = () => {
  const dispatch = useDispatch();
  const isProfileModalOpen = useSelector(selectIsProfileModalOpen);
  const isCanvasSizeModal = useSelector(selectIsCanvasSizeModal);

  const { userTemplates } = useSelector((state) => state.templates);

  const handleCloseModal = () => {
    dispatch(closeProfileModal());
  };

  useEffect(() => {
    if (!userTemplates.length) dispatch(loadUserTemplates());
  }, []);
  const handleCloseSizeModal = () => {
    dispatch(closeCansvasSizeModal());
  };

  return (
    <div className="flex">
      <Sidebar />
      <ContentArea />
      {isProfileModalOpen && <UserProfileModal onClose={handleCloseModal} />}
      {isCanvasSizeModal && <CanvasSizeModal onClose={handleCloseSizeModal} />}
    </div>
  );
};

export default TemplatesPage;
